var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Facebook Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2058_7754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.291687H14.2818V30H0V0.291687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2058_7754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.482 16.9275L14.1128 11.4904H9.27074V8.01835C9.27074 6.4441 9.6665 5.37099 11.6948 5.37099L14.2818 5.36959V0.505839C13.8358 0.44003 12.3001 0.291687 10.511 0.291687C6.77741 0.291687 4.22281 2.82571 4.22281 7.48031V11.4904H0V16.9275H4.22281V30H9.27074V16.9275H13.482Z",
    fill: "#FFDD00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookYellow);
export default __webpack_public_path__ + "static/media/facebook-yellow.deacf6f3f0eff7fbab8f330809483a9c.svg";
export { ForwardRef as ReactComponent };